import React from 'react';

import { ServiceableDays } from '../../components';
import { useDefaultReturnWindow } from '../context';

export default function Form() {
  const {
    data,
    initialData,
    errors,
    isProcessing,
    onChange
  } = useDefaultReturnWindow();

  return (
    <ServiceableDays
      chipSize="lg"
      value={data.serviceable_days}
      initialValue={initialData.serviceable_days}
      error={errors.serviceable_days}
      onChange={value => onChange({ serviceable_days: value })}
      isProcessing={isProcessing}
    />
  );
}
